export default {
  SET_ALL_LOCATIONS (state, data) {
    state.allLocations = data.entities
  }
}



// WEBPACK FOOTER //
// ./src/modules/location/store/mutations.js